import React from 'react';
import PropTypes from 'prop-types';
import Info from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const InformationTooltip = ({ size, ...props }) => (
  <Tooltip {...props}>
    <Info className={DEFAULT_ICON_CLASS_NAME} fontSize={size} />
  </Tooltip>
);

InformationTooltip.propTypes = {
  size: PropTypes.string,
};

InformationTooltip.defaultProps = {
  size: 'medium',
};

export default InformationTooltip;
